import React from "react";
import PropTypes from "prop-types";
import { Link as RouterLink, withRouter } from "react-router-dom";
import isApp from "shared/util/isApp";

const AppLink = withRouter(({ to, onClick, className, children, history }) => {
	const handleClick = (e) => {
		onClick(e);
		history.push(to);
	};

	return (
		<button
			type="button"
			className={className}
			onClick={handleClick}
		>
			{children}
		</button>
	);
});

const Link = ({ to, onClick, className, children, noSpa, ...otherProps }) => {
	if (noSpa) {
		return (
			<a
				className={className}
				href={to}
				onClick={onClick}
				{...otherProps}
			>
				{children}
			</a>
		);
	}

	if (isApp()) {
		return (
			<AppLink
				className={className}
				onClick={onClick}
				to={to}
				{...otherProps}
			>
				{children}
			</AppLink>
		);
	}

	return (
		<RouterLink
			className={className}
			to={to}
			onClick={onClick}
			{...otherProps}
		>
			{children}
		</RouterLink>
	);
};

Link.propTypes = {
	to: PropTypes.string.isRequired,
	onClick: PropTypes.func,
	children: PropTypes.any,
	className: PropTypes.string,
	noSpa: PropTypes.bool,
};

Link.defaultProps = {
	onClick: () => {},
	children: null,
	className: "",
	noSpa: false,
};

export default Link;



// WEBPACK FOOTER //
// ./src/shared/components/Link.jsx